const React = require('react');
const withState = require('../../../../../../utils/withState');
const {
  timer$,
} = require('../../emitters/resendVerification');
const TimerBase = require('./Base');


module.exports = withState(() => {
  return (state) => {
    return (
      <TimerBase
        time={state.timer}
      />
    );
  };
}, {
  timer: timer$,
});
